import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { OkAction, ErrorAction } from './baseActions';
import { feedbackService } from '../services/feedbackAPI';
import { formatApiErrorPayload } from './utils';

type AppState = import('~/store').AppState;

export enum FeedbackActionType {
  SEND_FEEDBACK = 'SEND_FEEDBACK',
  SEND_FEEDBACK_OK = 'SEND_FEEDBACK_OK',
  SEND_FEEDBACK_ERROR = 'SEND_FEEDBACK_ERROR',
}

type SendFeedbackAction =
  | Action<FeedbackActionType.SEND_FEEDBACK>
  | OkAction<FeedbackActionType.SEND_FEEDBACK_OK, void>
  | ErrorAction<FeedbackActionType.SEND_FEEDBACK_ERROR>;

export type FeedbackAction = SendFeedbackAction;

export const sendFeedback =
  (
    npsScore: number | undefined,
    email: string,
    message: string,
  ): ThunkAction<void, AppState, null, SendFeedbackAction> =>
  async (dispatch) => {
    dispatch({ type: FeedbackActionType.SEND_FEEDBACK });

    const response = await feedbackService.sendFeedback(npsScore, email, message);
    if (response.ok) {
      dispatch({
        type: FeedbackActionType.SEND_FEEDBACK_OK,
        data: response.data,
      });
    } else {
      dispatch({
        ...formatApiErrorPayload(response),
        type: FeedbackActionType.SEND_FEEDBACK_ERROR,
      });
    }
  };
